import MobileDetect from 'mobile-detect';

const deployEnv = () => {
  if (process.env.REACT_APP_DEPLOY_ENV === 'prod') {
    return 'prod';
  } else {
    return 'alpha';
  }
};

const isAlpha = deployEnv() === 'alpha';

const ALPHA_URL = 'https://jupiter-alpha.pklotcorp.com';
const PROD_URL = 'https://autopass.xyz';

const ALPHA_API_URL = 'https://api-alpha.pklotcorp.com';
const PROD_API_URL = 'https://api.autopass.xyz';

const ALPHA_MOCHIPAY_URL = 'https://payment-alpha.mochipay.xyz';
const PROD_MOCHIPAY_URL = 'https://payment.mochipay.xyz';

const ALPHA_CLIENT_UID = 'd451e968d472cb29ced4c149f805f67eab553198bf374dfa3a3bb9432a3b2304';
const PROD_CLIENT_UID = '51c8cf7db7e683e0241042d7bc27e5779a0545c07e89b9fdfdebf96fecfff8a2';

const ALPHA_MAPS_URL = 'https://enterprise-driver-alpha.pklotcorp.com/';
const PROD_MAPS_URL = 'https://enterprise-driver.autopass.xyz/';

const ALPHA_AMPLITUDE_KEY = '66dc0dace523f9dc7ab6afafa0221f25';
const PROD_AMPLITUDE_KEY = '47507a1850be09cdc0b0f7bfa5c324bd';

const ALPHA_MAINTENANCE_CONFIG_URL = 'https://maintenance-alpha.pklotcorp.com/config.json';
const PROD_MAINTENANCE_CONFIG_URL = 'https://maintenance.autopass.xyz/config.json';

export const termsUrl = isAlpha ? `${ALPHA_URL}/terms` : `${PROD_URL}/terms`;
export const privacyUrl = isAlpha ? `${ALPHA_URL}/privacy` : `${PROD_URL}/privacy`;
export const endPoint = isAlpha ? ALPHA_API_URL : PROD_API_URL;
export const mochipayUrl = isAlpha ? ALPHA_MOCHIPAY_URL : PROD_MOCHIPAY_URL;
export const clientUid = isAlpha ? ALPHA_CLIENT_UID : PROD_CLIENT_UID;
export const mapsUrl = isAlpha ? ALPHA_MAPS_URL : PROD_MAPS_URL;
export const amplitudeKey = isAlpha ? ALPHA_AMPLITUDE_KEY : PROD_AMPLITUDE_KEY;
export const maintenanceConfigUrl = isAlpha ? ALPHA_MAINTENANCE_CONFIG_URL : PROD_MAINTENANCE_CONFIG_URL;

export const ISO8601 = 'YYYY-MM-DDTHH:mm:ssZ';

export const WEBFLOW_INTRO_URL = 'https://mochi-biz.webflow.io/';
export const NOTIFICATION_TRANSFER_URL = 'https://pklotcorp.typeform.com/to/CIM0ltjG';
export const LINE_URL = 'https://lin.ee/odeUZbj';
const DESKTOP_AUTHENTICATOR_URL = 'https://support.google.com/accounts/answer/1066447';
const ANDROID_AUTHENTICATOR_URL =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
const IOS_AUTHENTICATOR_URL = 'https://appstore.com/googleauthenticator';

export const authenticatorUrl = userAgent => {
  const md = new MobileDetect(userAgent);
  switch (md.os()) {
    case 'iOS':
      return IOS_AUTHENTICATOR_URL;
    case 'AndroidOS':
      return ANDROID_AUTHENTICATOR_URL;
    default:
      return DESKTOP_AUTHENTICATOR_URL;
  }
};

export const isMobile = userAgent => {
  const md = new MobileDetect(userAgent);
  return md.os() === 'iOS' || md.os() === 'AndroidOS';
};
